export default defineNuxtPlugin(() => {
  const { captureFromUrl } = useTrackingAttribution()
  const router = useRouter()

  captureFromUrl(new URL(window.location.href))
  router.afterEach((to) => {
    captureFromUrl(new URL(to.fullPath, window.location.origin))
  })
})
